/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress } from '../../../../Fct/generics/FctParams';
import { supportedGauges } from '../helpers/supportedContracts';
export var ClaimRewards = createPlugin({
    protocol: 'CURVE',
    type: 'ACTION',
    method: 'claim_rewards',
    description: 'Claim rewards',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'curve_gauge',
                    options: supportedGauges.filter(function (pool) { return pool.chainId === Number(chainId); }),
                    isPreview: true,
                }),
                methodParams: {},
            },
            output: {},
        });
    },
});
